import Swiper from '../../components/swiper';
import * as _ from '../../components/lodash';

export default class TruncateStrings
{

    constructor( )
    {
        this.originalStrings = [];
    }

    createUniqueContainer( $items )
    {
        let originalStrings = this.originalStrings;

        $.each($items, function( i,val ){
            if( $(this).children().length > 1 && !$(this).hasClass('default-structure') ){
                var allStrings = [];

                $.each($(this).children(), function( i,val ) {
                    allStrings.push( $(this).text() );
                });

                $(this).children().remove();

                var _self = $(this);

                $.each(allStrings, function( i,val ) {
                    if( _self.children().length == 0 ){
                        _self.append('<p></p>');
                    }

                    let newText = _self.children().text() + ' ' + val;

                    _self.children().text( newText );

                    if( i + 1 == allStrings.length ){
                        originalStrings.push( _self.children().text() );
                    }
                });
            }
        });
    }

    truncateStrings( $items, options )
    {
        // Truncates strings
        let originalStrings = this.originalStrings;

        let truncateContentsNews = () => {
            let lengthMax = 0;

            _.forEach(options, function( value, key ) {
              if( window.innerWidth >= key ){
                lengthMax = value;
              }
            });
            $.each($items, function( i,val ){
                if( !$(this).hasClass('default-structure') ){
                    $(this).addClass('default-structure')
                }

                if( lengthMax > 0 ){
                    let stringToFormat = originalStrings[i],
                        stringFormated = stringToFormat.substr(0,lengthMax);

                    $(this).children().text( stringFormated + '...' );
                }
                else{
                    $(this).children().text( originalStrings[i] );
                }
            });
        };

        truncateContentsNews();
    }
}
